<template>
  <Modal
    class="relative"
    full-height
    :modal-style="{ maxWidth: '900px' }"
    :title="`Apply Users to ${briefSet.name}`"
  >
    <QSpinner
      v-if="loading"
      class="absolute-center"
      size="50"
    />
    <BriefSetUsersForm
      v-else
      v-model="briefSetUsers"
      class="full-height"
      :loading="loading"
      :users="organisationUsers"
    />

    <template #buttons>
      <BaseButton
        color="primary"
        label="Apply"
        new-design
        @click="save"
      />
    </template>
  </Modal>
</template>

<script>
import BaseButton from "shared/components/base/BaseButton.vue";
import Modal from "shared/components/core/modals/Modal.vue";
import { BriefSet, BriefSetsUser, Organisation } from "shared/resources";

import BriefSetUsersForm from "src/components/briefSets/BriefSetUsersForm.vue";

export default {
  name: "BriefSetUsersSelectionModal",
  components: {
    Modal,
    BriefSetUsersForm,
    BaseButton,
  },
  props: {
    briefSet: {
      type: Object,
      required: true,
    },
  },
  emits: ["confirm", "close"],
  data() {
    return {
      organisationUsers: [],
      briefSetUsers: null,
      updatedBriefSet: {},
      loading: true,
      originalUserIds: [],
    };
  },
  async mounted() {
    try {
      this.loading = true;

      await Promise.all([
        this.loadOrganisationUsers(),
        this.loadBriefSetUsers(),
      ]);
    } catch (error) {
      this.$error("Error loading organisation and brief set users", error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    save() {
      const enabledUsers = this.briefSetUsers.filter((user) => user.enabled);

      this.updatedBriefSet = {
        id: this.briefSet.id,
        user_ids: enabledUsers.map(({ id }) => id),
      };

      this.confirm();
    },
    confirm() {
      this.$emit("confirm", this.updatedBriefSet, this.originalUserIds);
      this.close();
    },
    close() {
      this.$emit("close");
    },
    async loadOrganisationUsers() {
      try {
        this.organisationUsers = (
          await Organisation.where({ archived: false, users: { active: true } })
            .includes("users")
            .select({ organisations: ["id"], users: ["name", "email"] })
            .selectExtra({ users: ["teamName"] })
            .find(this.briefSet.organisationId)
        ).data.users.map((user) => ({ ...user, id: user.id }));
      } catch (error) {
        this.$error("There was an issue loading users:", error);
      }
    },
    async loadBriefSetUsers() {
      const briefSetsUserScope = BriefSetsUser.where({ archived: false });

      const response = await BriefSet.includes("briefSetsUsers")
        .merge({ briefSetsUsers: briefSetsUserScope })
        .find(this.briefSet.id);

      this.briefSetUsers = response.data.briefSetsUsers;
      this.originalUserIds = this.briefSetUsers.map(({ userId }) => userId);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.container) {
  max-width: 80%;
}
</style>
